// extracted by mini-css-extract-plugin
export var active = "_9k-d";
export var blink = "_9k-e";
export var container = "_9k-5";
export var controls = "_9k-0";
export var controlsRight = "_9k-1";
export var fakeCursor = "_9k-c";
export var hidden = "_9k-b";
export var quillContainerSmall = "_9k-7";
export var quillEditor = "_9k-6";
export var quillEditorSmall = "_9k-8";
export var quillFormatButtons = "_9k-a";
export var quillToolbar = "_9k-9";
export var removePadding = "_9k-2";
export var state = "_9k-3";
export var stateTitle = "_9k-4";